"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./style.sass");
require("./step-arrow.svg");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Item = function Item(_ref) {
  var isActive = _ref.isActive,
    isCompleted = _ref.isCompleted,
    step = _ref.step,
    children = _ref.children,
    isClose = _ref.isClose,
    rest = _objectWithoutProperties(_ref, ["isActive", "isCompleted", "step", "children", "isClose"]);
  var className = (0, _classnames.default)(['step-wt', rest.className, {
    'step-wt_active': isActive,
    'step-wt_completed': isCompleted,
    'step-wt_close': isClose
  }]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "step-wt__wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "step-wt__icon"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "step-wt__num"
  }, step))), /*#__PURE__*/_react.default.createElement("div", {
    className: "step-wt__title"
  }, children));
};
var _default = Item;
exports.default = _default;